import React from "react";
import HeaderSubTitle from "../components/HeaderBackground";

import FormSection from "../components/pageContacto/form";

export default function Contacto() {
  return (
    <div className="routeContainer" style={{ backgroundColor: "white" }}>
      <HeaderSubTitle text={"contacto"}  color={"#E1903D"}></HeaderSubTitle>
      <div className="row g-0">
     <FormSection></FormSection>
     </div>
    </div>
  );
}
